/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/no-duplicate-string */

import {createTheme, css} from "@mui/material";

export const bombersTheme = createTheme({
	typography: {
		fontWeightRegular: 400,
		fontFamily: "var(--fontFamilyBase)",
		h1: {
			fontSize: "48px",
			fontStyle: "normal",
			lineHeight: 1,
			fontFamily: "var(--fontFamilySecond)",
			fontWeight: "normal",
			fontVariationSettings: "'wght' 800;",
			"@media (max-width: 860px)": {
				fontSize: "40px",
			},
		},
		header: {
			fontSize: "28px",
			fontStyle: "normal",
			lineHeight: 1,
			fontFamily: "var(--fontFamilySecond)",
			fontWeight: "normal",
			fontVariationSettings: "'wght' 700;",
		},
		h2: {
			fontSize: "40px",
			fontWeight: "normal",
			fontVariationSettings: "'wght' 800;",
			fontFamily: "var(--fontFamilySecond)",
		},
		h3: {
			fontSize: "32px",
			fontFamily: "var(--fontFamilySecond)",
			fontVariationSettings: "'wght' 800;",
			fontWeight: "normal",
		},
		h4: {
			fontSize: "28px",
			fontVariationSettings: "'wght' 800;",
			fontWeight: "normal",
			fontFamily: "var(--fontFamilySecond)",
		},
		h6: {
			fontSize: "16px",
			fontWeight: 700,
		},
		filter: {
			fontSize: "16px",
			fontWeight: 700,
			fontFamily: "var(--fontFamilyBase)",
		},
		subtitle1: {
			fontSize: "16px",
			fontWeight: 500,
		},
		caption: {
			fontSize: "12px",
			fontWeight: 600,
		},
		button: {
			fontSize: "18px",
			fontFamily: "var(--fontFamilySecond)",
			fontWeight: "normal",
			fontVariationSettings: "'wght' 800;",
			letterSpacing: "0.7px",
		},
		body1: {
			fontSize: "16px",
			fontWeight: 600,
		},
		body2: {
			fontSize: "14px",
			fontVariationSettings: "'wght' 800;",
			fontWeight: "normal",
		},
		link: {
			fontSize: "14px",
			fontWeight: 400,
			textDecoration: "underline",
		},
	},

	palette: {
		primary: {
			main: "#253E75",
			dark: "#806235",
			light: "#B99359",
		},
		secondary: {
			main: "#253E75",
			light: "#FDF4E5",
		},
		info: {
			main: "#fff",
			light: "#122247",
			dark: "#E2E7F3",
		},
		grey: {
			"50": "#F2F2F5",
			"100": "#E5E5EA",
			"200": "#C7C7CC",
			"300": "#AEAEB2",
			"400": "#8E8E93",
			"500": "#636366",
			"600": "#48484A",
			"700": "#3A3A3C",
			"800": "#2C2C2E",
			"900": "#1C1C1E",
			A100: "#f5f5f5",
			A200: "#eeeeee",
			A400: "#bdbdbd",
			A700: "#616161",
		},
		background: {
			default: "#e8e8e8",
			paper: "#FFFFFF",
			surface3: "rgba(197, 26, 32, 0.1)",
			widget: "#f0f3f7",
		},
		error: {
			contrastText: "#fff",
			dark: "rgb(170, 46, 37)",
			light: "rgb(246, 104, 94)",
			main: "#E40000",
		},
		success: {
			contrastText: "rgba(0, 0, 0, 0.87)",
			dark: "rgb(16, 140, 79)",
			light: "rgb(70, 211, 141)",
			main: "#18C971",
		},
		text: {
			disabled: "rgba(0, 0, 0, 0.38)",
			primary: "#101010",
			secondary: "#8E8E93",
		},
	},
	components: {
		MuiTypography: {
			variants: [
				{
					props: {className: "squad"},
					style: {
						color: "#122247",
					},
				},
			],
		},
		MuiCssBaseline: {
			styleOverrides: () => css`
				:root {
					--fontFamilySecond: "magno-serif-variable", sans-serif;
					--fontFamilyBase: "Proxima Nova", sans-serif;
					--primaryColor: #ff00ff;
					--secondaryColor: #18c971;
					--failColor: #f44336;
					--textColorMain: #2b2b2b;
					--textColor1: #000;
					--background: #e8e8e8;
					--background2: #202020;
					--background3: #545456;
					--background4: #525252;
					--iconErrorColor: #f44336;
					--textColor2: #e1ff67;
					--textColor3: #ffffff;
					--textColor4: #ffffff;
					--textColor5: #848484;
					--textColor6: #bebebe;
					--textColor7: #000000;
					--textColor8: #c7c7cc;
					--textColor9: #101010;
				}
			`,
		},
		MuiQuestionInnerContent: {
			styleOverrides: {
				root: {
					fontSize: "14px",
					fontVariationSettings: "'wght' 700;",
					fontWeight: "normal",
				},

				title: {
					fontSize: "14px",
					fontWeight: "700",
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {
					fontSize: "11px",
					fontFamily: "var(--fontFamilyBase)",
					color: "#AEAEB2",
					fontWeight: 500,
				},
				colorPrimary: {
					backgroundColor: "#253E75",
					color: "#FFF",
				},
				colorSecondary: {
					color: "rgb(255, 0, 255)",
					backgroundColor: "rgba(255, 0, 255, 0.1)",
				},
				colorSuccess: {
					color: "#008805",
					backgroundColor: "rgba(0, 136, 5, 0.15)",
				},
				colorError: {
					color: "#E40000",
					backgroundColor: "rgba(228, 0, 0, 0.15)",
				},
				colorInfo: {
					color: "#FFF",
					backgroundColor: "#806235",
					fontSize: 14,
				},
			},
		},
		MuiButton: {
			defaultProps: {
				disableElevation: true,
			},
			styleOverrides: {
				root: {
					textTransform: "none",
					borderRadius: 4,
					fontSize: "18px",
					fontFamily: "var(--fontFamilySecond)",
					fontWeight: "normal",
					fontVariationSettings: "'wght' 800;",
					letterSpacing: "0.7px",
					":disabled": {
						opacity: 0.3,
					},
				},
				contained: {
					textTransform: "uppercase",
					color: "#fff",
					":disabled": {
						color: "#FFFFFF",
						background: "#202020",
						opacity: 0.3,
					},
				},
				containedSecondary: {
					background: "#00ffff",
					border: "2px solid #00ffff",
					"&:hover": {
						background: "#3abdbd",
					},
				},
				outlined: {
					textTransform: "uppercase",
					color: "#000",
				},
			},
		},
		MuiSvgIcon: {
			styleOverrides: {
				colorSuccess: {
					color: "#18C971",
				},
				colorError: {
					color: "#F44336",
				},
				colorInfo: {
					color: "#2196F3",
				},
				colorAction: {
					color: "#000",
				},
				colorSecondary: {
					color: "#00ffff",
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					borderRadius: "4px",
					"& .MuiOutlinedInput-root": {
						"& fieldset": {},
						"&.Mui-focused fieldset": {
							borderTop: "none",
							borderLeft: "none",
							borderRight: "none",
							border: "2px solid #0B1E46",
						},
					},
				},
			},
		},
		MuiTabs: {
			styleOverrides: {
				root: {
					textTransform: "none",
				},
				flexContainer: {
					borderBottom: "2px solid gray",
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					fontWeight: "normal",
					fontVariationSettings: "'wght' 800;",
					textTransform: "none",
					fontSize: "20px",
					"&.Mui-selected, .active": {
						color: "#253E75",
						borderBottom: "2px solid #253E75",
					},
				},
			},
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					background: "#FFF",
					color: "var(--primaryColor)",
				},
			},
		},
		MuiTableHead: {
			styleOverrides: {
				root: {
					background: "var(--primaryColor)",
					color: "var(--textColor4)",
				},
			},
		},

		MuiTableRow: {
			styleOverrides: {
				root: {
					"&.own-user": {
						background: "#806235",
						"&: hover": {
							background: "#253E75",
						},
					},
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					fontSize: "16px",
					fontWeight: 600,
					padding: "5px 16px 5px 20px",
					".own-user &": {
						color: "#fff",
						"&: hover": {
							color: "#fff",
						},
					},
				},
			},
		},
		MuiSnackbar: {
			defaultProps: {
				anchorOrigin: {
					horizontal: "right",
					vertical: "bottom",
				},
				autoHideDuration: 5000,
			},
		},
		MuiSnackbarContent: {
			styleOverrides: {
				root: {
					background: "#ffffff",
					color: "#000",
				},
			},
		},
		MuiList: {
			styleOverrides: {
				root: {
					background: "transparent",
					color: "#2b2b2b",
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					fontWeight: 400,
				},
			},
		},
	},
});
